var appUrl = "https://0sa1.elglobo.com.mx";
var appUrlSuc = "https://0sa1.elglobo.com.mx";
//var appUrlSuc = 'https://0sa1.elglobo.com.mx';
//var appUrlDeliv = 'https://0sa1.elglobo.com.mx/staging/public';
var appUrlDeliv = "https://0sa1.elglobo.com.mx";
var sucursales_hardcodeadas = [];
var currentTime = new Date();
var allowHideProductos = false; // Controla si hideProductos puede ejecutarse
var p_sortered = false;
var p_filtered = false;
var allFetchedProducts = [];
var allFetchedFilteredProducts = [];
/*
var sucursales_hardcodeadas= [{
    "direccion":"Lazaro Pavia 300, Jardin Balbuena, Venustiano Carranza, 15900 Ciudad de Mexico, CDMX",
    "ecommerce":"1",
    "estatus":"1",
    "horario": "Lun a Dom de  07:00 a 21:30 hrs",
    "lat":"19.417003",
  "lon":"-99.115255",
  "nombre": "ROMA-Balbuena-Lab 3001",
  "numero":"S3001",
  "telefono": "5557681349",
  "tipo": "EL GLOBO"
},{
    "direccion":"Plaza de Santa María local 14 Av. Manuel Carpio 99 esquina Doctor Altamirano Col. Santa María la Rivera del Cuauhtémoc Distrito Federal CP 03400",
    "ecommerce":"1",
    "estatus":"1",
    "horario": "Lun a Dom de  07:00 a 21:30 hrs",
    "lat":"19.451026",
  "lon":"-99.156089",
  "nombre": "SUCURSAL NUEVA SANTA MARIA - 3025",
  "numero":"3025",
  "telefono": "55 55471930",
  "tipo": "EL GLOBO"
},{
    "direccion":"Av. Lázaro Pavia 300 Col Jardín Balbuena del Venustiano Carranza Distrito Federal CP 15900",
    "ecommerce":"1",
    "estatus":"1",
    "horario": "Lun a Dom de  07:00 a 21:30 hrs",
    "lat":"19.417197",
  "lon":"-99.115236",
  "nombre": "SUCURSAL BALBUENA - 3008",
  "numero":"3008",
  "telefono": "55 57 68 13 49",
  "tipo": "EL GLOBO"
}];
*/
var sucursal;
//var mbProductos = JSON.parse(localStorage.getItem('mbProductos'));
var mbProductos = localStorage.getItem("mbProductos");
var dirsuc = localStorage.getItem("suc_dir");
var cartSubmit = 0;
var discount_param = "";
//const sucursales_delivery= ["S3131", "S3155", "S3099", "S3140","S3470","S3143","S3426"];
//const sucursales_delivery= ["fake"];
const sucursales_lealtad = [
  "S3014",
  "S3131",
  "S3155",
  "S3099",
  "S3140",
  "S3470",
  "S3143",
  "S3426",
  "S3008",
  "S3063",
  "S3008",
  "S3065",
  "S3040",
  "S3071",
  "S3043",
  "S3424",
  "S3080",
  "S3003",
  "S3066",
  "S3144",
  "S3323",
  "S3267",
  "S3052",
  "S3002",
  "S3027",
  "S3012",
  "S3054",
  "S3085",
  "S3428",
  "S3131",
  "S3155",
  "S3099",
  "S3140",
  "S3470",
  "S3143",
  "S3426",
  "S3063",
  "S3008",
  "S3065",
  "S3040",
  "S3071",
  "S3043",
  "S3424",
  "S3080",
  "S3003",
  "S3144",
  "S3323",
  "S3267",
  "S3052",
  "S3002",
  "S3027",
  "S3012",
  "S3054",
  "S3085",
  "S3428",
  "S3005",
  "S3444",
  "S3091",
  "S3018",
  "S3095",
  "S3011",
  "S3475",
  "S3007",
  "S3137",
  "S3025",
  "S3029",
  "S3057",
  "S3126",
  "S3251",
  "S3088",
  "S3431",
  "S3084",
  "S3262",
  "S3288",
  "S3036",
  "S3439",
  "S3041",
  "S3010",
  "S3202",
  "S3114",
  "S3035",
  "S3121",
  "S3039",
  "S3024",
  "S3016",
  "S3147",
  "S3067",
  "S3188",
  "S3066",
  "S3265",
  "S3449",
  "S3038",
  "S3047",
  "S3446",
  "S3458",
  "S3019",
  "S3435",
  "S3009",
  "S3056",
  "S3204",
  "S3182",
  "S3357",
  "S3061",
  "S3372",
  "S3092",
  "S3175",
  "S3148",
  "S3072",
  "S3073",
  "S3142",
  "S3280",
  "S3133",
  "S3463",
  "S3285",
  "S3432",
  "S3045",
  "S3430",
  "S3139",
  "S3109",
  "S3206",
  "S3094",
  "S3077",
  "S3118",
  "S3108",
  "S3127",
  "S3189",
  "S3102",
  "S3116",
  "S3462",
  "S3293",
  "S3192",
  "S3086",
  "S3473",
  "S3059",
  "S3413",
  "S3076",
  "S3436",
  "S3396",
  "S3117",
  "S3461",
  "S3452",
  "S3089",
  "S3377",
  "S3120",
  "S3441",
  "S3198",
  "S3467",
  "S3474",
  "S3466",
  "S3310",
  "S3081",
  "S3478",
  "S3050",
  "S3145",
  "S3454",
  "S3103",
  "S3058",
  "S3129",
  "S3442",
  "S3486",
  "S3391",
  "S3425",
  "S3465",
  "S3199",
  "S3472",
  "S3055",
  "S3181",
  "S3321",
  "S3105",
  "S3021",
  "S3272",
  "S3476",
  "S3172",
  "S3456",
  "S3445",
  "S3477",
  "S3355",
  "S3480",
  "S3468",
  "S3460",
  "S3374",
  "S3030",
  "S3469",
  "S3020",
  "S3104",
  "S3115",
  "S3464",
  "S3331",
  "S3332",
  "S3082",
  "S3277",
  "S3275",
  "S3453",
  "S3457",
  "S3434",
  "S3479",
];
const sucursales_delivery = [
  "S3085",
  "S3027",
  "S3077",
  "S3426",
  "S3025",
  "S3008",
];

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const test_param = urlParams.get("test");
if (test_param == "true") {
  localStorage.setItem("released", "true");
  console.log(test_param);
} else {
  if (localStorage.getItem("released") != "true") {
    localStorage.removeItem("released");
  }
}

if (dirsuc == null) {
  sucursal = null;
} else {
  sucursal = localStorage.getItem("sucursal");
}
console.log(sucursal);

if (sucursal == null) {
  console.log("Sucursal no ha sido seleccionada");

  //window.location.replace('https://elglobomx.myshopify.com/pages/sucursales');
} else {
  var cartAttributes = {
    attributes: {
      sucursal: localStorage.getItem("sucursal"),
      direccionSucursal: localStorage.getItem("suc_dir"),
      horarioSucursal: localStorage.getItem("suc_horario"),
      telefonoSucursal: localStorage.getItem("suc_tel"),
      latSucursal: localStorage.getItem("suc_lat"),
      lonSucursal: localStorage.getItem("suc_lon"),
      lonCliente: localStorage.getItem("dir_lon"),
      latCliente: localStorage.getItem("dir_lat"),
      uberQuoteId: localStorage.getItem("quote_id"),
      uberQuoteExpiration: localStorage.getItem("quote_expiration"),
      direccionCliente:
        localStorage.getItem("dir_street") +
        " " +
        localStorage.getItem("dir_city") +
        " " +
        localStorage.getItem("dir_postal_code") +
        " " +
        localStorage.getItem("dir_country"),
    },
  };

  $.post("/cart/update.js", cartAttributes);
  sucursal = sucursal.replace("S", "");
  console.log("La sucursal elegida es: " + sucursal);
  getProductos();
  //hideProductos();
  showBebidas();
}

function getProductos() {
  console.log("obtener los productos de la sucursal: " + sucursal);

  var params = "?";
  params += "suc=" + sucursal;

  var requestOptions = {
    method: "GET",
    //headers: myHeaders,
    redirect: "follow",
    //mode: 'cors'
  };
  console.log(appUrl + "/shopify/getproductos" + params);
  fetch(appUrl + "/shopify/getproductos" + params, requestOptions)
    .then((response) => response.json())
    .then(function (data) {
      localStorage.setItem("mbProductosJSN", JSON.stringify(data));
      mbProductos = data;
      localStorage.setItem("mbProductos", mbProductos);
      // hideProductos();
    })
    .catch((error) => console.log("error", error));
}

function buscarProductoInfoPorSku(sku) {
  if (typeof mbProductos !== "undefined") {
    for (var k in mbProductos) {
      if (mbProductos[k].sku == sku) {
        return mbProductos[k];
        break;
      }
    }
  }
}

function removeCliDirection() {
  localStorage.removeItem("dir_firstname");
  localStorage.removeItem("dir_lastname");
  localStorage.removeItem("dir_telephone");
  localStorage.removeItem("dir_street");
  localStorage.removeItem("dir_apartment");
  localStorage.removeItem("dir_postal_code");
  localStorage.removeItem("dir_city");
  localStorage.removeItem("dir_state");
  localStorage.removeItem("dir_country");
  localStorage.removeItem("dir_reference");
  localStorage.removeItem("dir_indications");
  localStorage.removeItem("dir_lat");
  localStorage.removeItem("dir_lon");

  localStorage.removeItem("address1");
  localStorage.removeItem("address2");
  localStorage.removeItem("zip");
  localStorage.removeItem("city");
  localStorage.removeItem("suggestion_lat");
  localStorage.removeItem("suggestion_lon");
}

function removeSucData() {
  localStorage.removeItem("suc_dir");
  localStorage.removeItem("suc_name");
  localStorage.removeItem("suc_lat");
  localStorage.removeItem("suc_lon");
  localStorage.removeItem("sucursal");
}
function removeUberQuote() {
  localStorage.removeItem("quote_fee");
  localStorage.removeItem("quote_id");
  localStorage.removeItem("quote_duration");
}

var isFiltering = false; // Indica si el evento actual es un filtrado
var initialLoadCompleted = false;
function hideProductos() {
  console.log("Ejecutando hideProductos durante el filtrado...");

  if (mbProductos && Array.isArray(mbProductos)) {
    $("[data-sga-prd-sku]").each(function () {
      var element = $(this);
      var sku = element.attr("data-sga-prd-sku");
      var button_id = element.attr("data-addtc-button");
      var prod_type = $(element).attr("data-type-prod");
      var productoData = buscarProductoInfoPorSku(sku);

      if (productoData) {
        if (productoData.qty > 0) {
          // Si hay stock, muestra el botón y oculta el mensaje
          element.find(".quantity-selector").show();
          $("#" + button_id).show();
          element.find(".no-stock-message").hide();
        } else {
          // Si no hay stock, oculta el botón y muestra el mensaje, excepto para bebidas
          if (prod_type !== "BEBIDAS") {
            element.find(".quantity-selector").hide();
            $("#" + button_id).hide();
            element.find(".no-stock-message").show();
          }
        }
      } else {
        // Si no se encuentra el producto, oculta el botón y muestra el mensaje, excepto para bebidas
        if (prod_type !== "BEBIDAS") {
          element.find(".quantity-selector").hide();
          $("#" + button_id).hide();
          element.find(".no-stock-message").show();
        }
      }
    });
  } else {
    console.error("Error: Los datos de inventario no están disponibles.");
  }
}

/*function hideBuscadorProductos() {
  if (typeof mbProductos !== null) {
    $.each($("[data-sga-prdsearch-sku]"), function (index, element) {
      console.log($(element).attr("data-sga-prdsearch-sku"));
      var productoData = buscarProductoInfoPorSku(
        $(element).attr("data-sga-prdsearch-sku")
      );
      var tags = $(element).attr("data-sga-prdsch-tags");
      console.log(productoData);

      if (typeof productoData !== "undefined") {
        if (productoData.qty > 0 || tags.indexOf("visibleallways") >= 0) {
          
        } else {
          $(element).hide();
        }
      } else {
        if (tags.indexOf("visibleallways") == 0 || tags == "") {
          $(element).hide();
        }
      }
    });
  }
}*/

function showBebidas() {
  $.each($("[data-sga-prd-sku]"), function (index, element) {
    //console.log($(element).attr('data-sga-tags'));
    var tags = $(element).attr("data-sga-tags");

    if (tags.indexOf("visibleallways") >= 0) {
      $(element).show();
    }
  });
}

function validateMaxQty(element) {
  var qty = parseInt($(element).val());
  var frm = $(element).closest("form");
  var sku = $(frm).find("input[data-sku]").attr("data-sku");

  if (sku == "" || typeof sku === "undefined") {
    var sku = $(frm).find('input[name="sku"]').val();
  }

  var productoData = buscarProductoInfoPorSku(sku);
  //console.log('productoData ',productoData);

  if (typeof productoData !== "undefined") {
    if (current_collection == "BEBIDAS") {
      //console.log('******* estamos en bebidas ********',productoData);
      // $(element).attr('size',1000);
      //$(element).val(1);
    } else {
      if (qty > parseInt(productoData.qty)) {
        if (parseInt(productoData.qty) == 0) {
        } else {
          $(element).val(productoData.qty);
        }
      } else {
      }
    }
  }
}

function validateCartMaxQty(element, type) {
  var qty = parseInt($(element).val());
  var parent = $(element).closest("tr");
  var sku = $(parent).attr("data-sku");

  if (type == "btn-mas") {
    qty = qty + 1;
  }
  if (type == "btn-menos") {
    qty = qty - 1;
  }

  console.log("carrito val");
  console.log(sku + ":" + qty);

  var productoData = buscarProductoInfoPorSku(sku);
  console.log(productoData);
  if (typeof productoData !== "undefined") {
    if (qty > parseInt(productoData.qty)) {
      if (type == "btn-mas") {
        $(parent)
          .find('[data-action="increase-quantity"]')
          .attr("data-quantity", productoData.qty);
      }
      if (type == "btn-menos") {
        $(parent)
          .find('[data-action="decrease-quantity"]')
          .attr("data-quantity", productoData.qty - 1);
      }
      if (type == "input") {
        $(element).val(productoData.qty);
      }
    }
  }
}

function validarHorarioSucursal(element) {
  console.log("validarHorarioSucursal: ");
  var params = "?";
  params += "suc=" + sucursal;

  var requestOptions = {
    method: "GET",
    //headers: myHeaders,
    redirect: "follow",
    //mode: 'cors'
  };

  fetch(appUrl + "/shopify/validarhorariosucursal" + params, requestOptions)
    .then((response) => response.json())
    .then(function (data) {
      data.en_horario = true; // Hardcodeado, Obligando a que entre siempre en horario, comentar para un uso normal
      console.log("En horario: ");
      console.log(data.en_horario);
      if (data.en_horario) {
        localStorage.setItem("en_horario", "true");

        cartSubmit = 1;
        $('#frm-cart-recap button[name="checkout"]').click();
      } else {
        localStorage.setItem("en_horario", "false");
        $("modal-horario-horarios").text(data.horario_apertura + " hrs");
        $("#modal-horario-nbrsuc").text(localStorage.getItem("suc_name"));
        $("#modal-horario").fadeIn("fast").focus();
        $(".backdrop").fadeIn("fast");
      }
    })
    .catch((error) => console.log("error", error));
}

/*$('body').on('change', 'div.collection', function(){
  console.log('changed paged');
});*/

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };
// Select the node that will be observed for mutations

// Selecciona el contenedor que se actualiza al filtrar
const targetNode = document.getElementById("collection__dynamic-part");

let collectionObserver; // Variable global para el observer

function attachCollectionObserver() {
  /*
  const targetNode = document.getElementById("collection__dynamic-part");
  if (targetNode !== null) {
    const config = { attributes: true, childList: true, subtree: true };
    const callback = function (mutationsList, observer) {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          // Asegúrate de que la carga inicial ya terminó
          if (!initialLoadCompleted) {
            console.log("Carga inicial en curso, no se ejecuta hideProductos.");
            return;
          }
          // Ejecuta hideProductos solo cuando se realiza un filtrado
          console.log(
            "Detectado cambio en el DOM. Ejecutando hideProductos..."
          );
          $("#prd-loading-icon").show();
          allowHideProductos = true;
          isFiltering = true; // Se activa el estado de filtrado
          //hideProductos(); // Llama a hideProductos
          showBebidas();
          isFiltering = false;
          allowHideProductos = false;
          // Oculta el ícono de carga después de 5 segundos
          setTimeout(() => {
            $("#prd-loading-icon").hide();
          }, 5000);
        }
      });
    };
    collectionObserver = new MutationObserver(callback);
    collectionObserver.observe(targetNode, config);
  }
  */
}

function detachCollectionObserver() {
  if (collectionObserver) {
    collectionObserver.disconnect();
  }
}

//se usa para visualizar botones de agregar y cantidad a lo productos de busqueda  (dependiendo de qty) de lo contrario el mensaje
function hideBuscadorProductos() {
  if (!Array.isArray(mbProductos) || mbProductos.length === 0) {
    const stored = localStorage.getItem("mbProductosJSN");
    if (stored) {
      try {
        mbProductos = JSON.parse(stored);
      } catch (e) {
        mbProductos = [];
      }
    }
    if (!Array.isArray(mbProductos) || mbProductos.length === 0) {
      return getProductos().then(hideBuscadorProductos);
    }
  }

  $(".collection__dynamic-part [data-sga-prd-sku]").each(function () {
    const $el = $(this);
    const sku = $el.data("sga-prd-sku") + "";
    const tags = $el.data("sga-tags") || "";
    const tipoProd = $el.data("type-prod") || "";

    const productoData = buscarProductoInfoPorSku(sku);
    const visibleAlways = tags.includes("visibleallways");
    const hayStock = productoData && productoData.qty > 0;

    const $form = $el.find(".product-item__action-list");
    const $btn = $el.find(".product-link");
    const $qty = $el.find(".quantity-selector");
    const $opciones = $el.find(".bold_options");
    let $msg = $el.find(".no-stock-message");

    if (!$msg.length) {
      $msg = $(
        '<div class="no-stock-message">DISPONIBLE SOLO EN SUCURSAL</div>'
      )
        .css({ marginTop: "0.5em", fontWeight: "bold" })
        .appendTo($el.find(".item-details-col").last());
    }

    // Si es bebida, ocultar opciones y normalizar botón
    if (tipoProd.toUpperCase() === "BEBIDAS") {
      $opciones.hide();
      $form.css("display", "block");

      $btn
        .removeClass()
        .addClass(
          "icon-addtocart-button product-item__action-button product-item__action-button--list-view-only button button--small button--primary"
        )
        .css({ display: "block" });
    }

    if (hayStock || visibleAlways) {
      $form.show();
      $btn.show();
      $qty.show();
      $msg.hide();
    } else {
      $form.hide();
      $btn.hide();
      $qty.hide();
      $msg.show();
    }
  });
}

//  observer necesario en página de búsqueda
/*
if (window.location.pathname.includes("/search")) {
  const searchResultsElem = document.querySelector(".collection__dynamic-part");

  if (searchResultsElem) {
    console.log("Observer: Inicializado para página de búsqueda");

    let debounceTimeout;
    const observer = new MutationObserver(function (mutationsList) {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        const productosVisibles = searchResultsElem.querySelectorAll("[data-sga-prd-sku]");
        if (productosVisibles.length > 0) {
          console.log("Observer: Productos detectados, ejecutando hideBuscadorProductos");
          hideBuscadorProductos();
        } else {
          console.log("Observer: No se detectaron productos");
        }
      }, 250);
    });

    observer.observe(searchResultsElem, {
      childList: true,
      subtree: true
    });
    hideBuscadorProductos();
  } else {
    console.log("Observer: No se encontró .collection__dynamic-part");
  }
}
*/

// Select the node that will be observed for mutations
/*const targetNode2 = document.getElementsByClassName("search-bar__inner");

if (targetNode2 !== null) {
  
  const callback2 = function (mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        console.log("Buscador actualizado");
        hideBuscadorProductos();
      }
    }
  };
  const observer2 = new MutationObserver(callback2);
  observer2.observe(targetNode2[0], config);*/

// Later, you can stop observing
//observer.disconnect();
//}
//---FIN OBSERVER 2

/*/---OBSERVER 3
// Select the node that will be observed for mutations
const targetNode3 = document.getElementById('mini-cart');

if(targetNode3 !== null){
    // Callback function to execute when mutations are observed
    const callback3 = function(mutationsList, observer) {
        // Use traditional 'for loops' for IE 11
        for(const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                console.log('mini carrito actualizado');
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer3 = new MutationObserver(callback3);

    // Start observing the target node for configured mutations
    observer3.observe(targetNode3, config);

    // Later, you can stop observing
    //observer.disconnect();
}
//---FIN OBSERVER 3 */

$(document).ready(function () {
  // if(sucursales_lealtad.includes(localStorage.getItem('sucursal'))&&localStorage.getItem('released')){ oculto para pruebas
  if (sucursales_lealtad.includes(localStorage.getItem("sucursal"))) {
    $(".lealtad").show();
  }
  //Validar qty a agregar en quick view y detalle de producto
  $(document).on("input change", 'input[name="quantity"]', function () {
    validateMaxQty(this);
  });
  $(document).on(
    "click",
    '[data-action="decrease-picker-quantity"]',
    function () {
      var frm = $(this).closest("form");
      var input = $(frm).find('input[name="quantity"]');
      validateMaxQty(input);
    }
  );
  $(document).on(
    "click",
    '[data-action="increase-picker-quantity"]',
    function () {
      var frm = $(this).closest("form");
      var input = $(frm).find('input[name="quantity"]');
      validateMaxQty(input);
    }
  );

  //Validar qty a agregar en pagina de carrito
  $(document).on("input change", "input.quantity-selector__value", function () {
    validateCartMaxQty(this, "input");
  });
  /*$(document).on('click', '[data-action="decrease-quantity"]', function() { 
        var parent = $(this).closest('tr');
        var input = $(parent).find('input.quantity-selector__value');
        validateCartMaxQty(input,'btn-menos');
    });
    $(document).on('click', '[data-action="increase-quantity"]', function() { 
        var parent = $(this).closest('tr');
        var input = $(parent).find('input.quantity-selector__value');
        validateCartMaxQty(input,'btn-mas');
    });*/

  //Selectores de cantidad en collections o rejillas
  $(document).on(
    "click",
    '[data-action="custom-increase-quantity"]',
    function () {
      var parent = jQuery(this).closest("div[data-sga-prd-sku]");
      var qty = jQuery(parent).find('input[name="quantity"]').val();
      qty = parseInt(qty) + 1;
      jQuery(parent).find('input[name="quantity"]').val(qty);

      var input = $(parent).find('input[name="quantity"]');
      validateMaxQty(input);
    }
  );

  $(document).on(
    "click",
    '[data-action="custom-decrease-quantity"]',
    function () {
      var parent = jQuery(this).closest("div[data-sga-prd-sku]");
      var qty = jQuery(parent).find('input[name="quantity"]').val();
      qty = parseInt(qty) - 1;
      if (qty < 1) {
        qty = 1;
      }
      jQuery(parent).find('input[name="quantity"]').val(qty);

      var input = $(parent).find('input[name="quantity"]');
      validateMaxQty(input);
    }
  );
  //Fin selectores de cantidad

  //$('div.page__sub-header div.page__navigation').remove();

  //Fin validar qty en quick view y en detalle de producto

  $(document).on("submit", "#frm-cart-recap", function (e) {
    if (cartSubmit == 0) {
      e.preventDefault();
      validarHorarioSucursal(this);
    }
  });

  setTimeout(function () {
    $(".eg-megamenu-item span:contains('FAVORITOS DEL MES')")
      .parent()
      .parent()
      .parent()
      .remove();
  }, 500);
});

//---Programa lealtad---
var misPuntos = 0;

/*function PLConsultaPuntos() {
  var params = "?";
  params += "cliId=" + $("#PLClientId").val();

  var requestOptions = {
    method: "GET",
    //headers: myHeaders,
    redirect: "follow",
    //mode: 'cors'
  };

  $("#PLContainer").hide();
  $("#PLLoadingImg").show;

  fetch(appUrl + "/shopify/plconsultapuntos" + params, requestOptions)
    .then((response) => response.json())
    .then(function (data) {
      console.log(data);
      $("#PLContainer").show();
      $("#PLLoadingImg").hide;

      if (data.status) {
        misPuntos = data.puntos;
        $("#misPuntosInfo").text(data.puntos);
        $("#misPuntosInfo2").text(data.puntos);
        $(".sin-redimir").hide();
      } else {
        $("#txtPuntos").remove();
        $("#btnUsarPuntos").remove();
        $(".aplica-puntos").remove();
        //$('#programaLealtadMsg').html('<b >No estás dado de alta en el programa de lealtad o hubo un problema al consultar tus puntos.</b>');
        $("#programaLealtadMsg").html(data.message);
      }
    })
    .catch((error) => console.log("error", error));
}*/
async function PLConsultaPuntos() {
  const $msg = $("#programaLealtadMsg");
  const $loader = $("#PLLoadingImg");
  const $container = $("#PLContainer");
  const clientId = $("#PLClientId").val();

  $msg.text("");
  $container.hide();
  $loader.show();

  try {
    const response = await fetch(
      `${appUrl}/shopify/plconsultapuntos?cliId=${clientId}`
    );
    const data = await response.json();

    $loader.hide();
    $container.show();

    if (data.status) {
      misPuntos = data.puntos;
      $("#misPuntosInfo, #misPuntosInfo2").text(data.puntos);
      $(".sin-redimir").hide();
    } else {
      $("#txtPuntos, #btnUsarPuntos, .aplica-puntos").remove();
      $msg.html(
        data.message || "No estás dado de alta en el programa de lealtad."
      );
    }
  } catch (error) {
    console.error("Error al consultar puntos:", error);
    $loader.hide();
    $msg.html("<b>No pudimos obtener tus puntos. Intenta más tarde.</b>");
  }
}

/*function PLTmpCongelarPuntos(discount){ 
  var amt = $('#txtPuntos').val();
  var params = '?';
  params += "cliId=" + $('#PLClientId').val();
  params += "&puntos=" + $('#txtPuntos').val();
  params += "&sucNum=" + sucursal;
  params += "&sucNom=" + localStorage.getItem('suc_name');
  params += "&code=" + discount;

  var requestOptions = {
    method: 'GET',
    //headers: myHeaders,
    redirect: 'follow'
    //mode: 'cors'
  };
  
  $('#PLContainer').hide();
  $('#PLLoadingImg').show;
  
  fetch(appUrl+"/shopify/pltmpcongelarpuntos"+params, requestOptions)
  .then(response => response.json())
  .then(function(data){
    console.log(data);
    $('#PLLoadingImg').show();
    $('#PLContainer').show();
    
    if(data.status){
      $.post('/cart/update.js', "attributes[folioRedencion]="+data.folio);
      $('#btnCancelarPuntos').attr('data-folio', data.folio);
      
      $('#frm-cart-recap [name="discount"]').val(discount);
      $('#puntosAplicados').text(amt);
      
      $('#frmPuntos').hide();
      $('#dsctoPuntosInfo').show();
      $('#dsctoPuntosInfo1').show();

      PLConsultaPuntos();
      $('#programaLealtadMsg').html('<span style="color: #8b384a">¡Listo! serán aplicados previo a tu pago</span>');
    }else{
      $('#frmPuntos').show();
      $('#programaLealtadMsg').html('<b>Hubo un problema al aplicar el descuento, vuelve a intentarlo por favor.</b>');
    }
  }).catch(error => console.log('error', error));
}*/

/*function PLUsarPuntos() {
  var amt = $("#txtPuntos").val();

  var data = {
    cliId: $("#PLClientId").val(),
    monto: amt,
    sucNum: sucursal,
    sucNom: localStorage.getItem("suc_name"),
  };

  var requestOptions = {
    method: "POST",
    body: JSON.stringify(data),
    redirect: "follow",
  };

  fetch(appUrl + "/shopify/plusarpuntos", requestOptions)
    .then((response) => response.json())
    .then(function (data) {
      console.log(data);
      if (data.status) {
        if (data.descuento.saldoSuficiente) {
          $.post(
            "/cart/update.js",
            "attributes[folioRedencion]=" + data.descuento.folio
          );
          console.log("descuento: " + data.descuento.folio);
          $("#btnCancelarPuntos").attr("data-folio", data.descuento.folio);
          $('#frm-cart-recap [name="discount"]').val(data.descuento.code);

          $("#puntosAplicados").text(amt);

          $("#frmPuntos").hide();
          $(".podria-acumular").hide();

          $("#dsctoPuntosInfo").show();
          $("#dsctoPuntosInfo1").show();
          $("#prevPuntosContainer").hide();
          discount_param = data.descuento.code;
          //$("#frm-cart-recap").attr('action',$("#frm-cart-recap").attr('action')+ "&discount="+discount_param);
          PLConsultaPuntos();
          $("#programaLealtadMsg").html(
            '<span style="color: #8b384a">¡Listo! serán aplicados previo a tu pago</span>'
          );
        } else {
          $("#frmPuntos").show();
          $("#programaLealtadMsg").html("<b>Saldo insuficiente.</b>");
        }
      } else {
        $("#frmPuntos").show();
        $("#programaLealtadMsg").html(
          "<b>Hubo un problema al aplicar el descuento, vuelve a intentarlo por favor.</b>"
        );
      }
    })
    .catch((error) => console.log("error", error));
}*/

async function PLUsarPuntos() {
  const $msg = $("#programaLealtadMsg");
  const $btn = $("#btnUsarPuntos");

  const amt = parseInt($("#txtPuntos").val(), 10);
  const data = {
    cliId: $("#PLClientId").val(),
    monto: amt,
    sucNum: sucursal,
    sucNom: localStorage.getItem("suc_name"),
  };

  // UI - Inicio de carga
  $btn.prop("disabled", true).text("Procesando...");
  $msg.text("");

  try {
    const response = await fetch(appUrl + "/shopify/plusarpuntos", {
      method: "POST",
      body: JSON.stringify(data),
      redirect: "follow",
    });

    const result = await response.json();

    if (!result.status) {
      $msg.html("<b>Error al aplicar los puntos. Intenta de nuevo.</b>");
      $btn.prop("disabled", false).text("Usar puntos");
      return;
    }

    if (!result.descuento.saldoSuficiente) {
      $msg.html("<b>Saldo insuficiente para aplicar el descuento.</b>");
      $btn.prop("disabled", false).text("Usar puntos");
      return;
    }

    // Aplicar descuento
    $.post(
      "/cart/update.js",
      "attributes[folioRedencion]=" + result.descuento.folio
    );
    $("#btnCancelarPuntos").attr("data-folio", result.descuento.folio);
    $('#frm-cart-recap [name="discount"]').val(result.descuento.code);
    $("#puntosAplicados").text(amt);

    $("#frmPuntos").hide();
    $(".podria-acumular").hide();
    $("#dsctoPuntosInfo").show();
    $("#dsctoPuntosInfo1").show();
    $("#prevPuntosContainer").hide();

    discount_param = result.descuento.code;
    await PLConsultaPuntos(); // refresca puntos

    $msg.html(
      '<span style="color: #8b384a">¡Listo! serán aplicados previo a tu pago</span>'
    );
  } catch (error) {
    console.error("Error de red:", error);
    $msg.html("<b>No se pudo conectar con el servidor. Intenta más tarde.</b>");
  } finally {
    $btn.prop("disabled", false).text("Usar puntos");
  }
}

async function PLCancelarPuntos(folio) {
  const $msg = $("#programaLealtadMsg");
  const $loader = $("#PLLoadingImg");
  const $container = $("#PLContainer");

  const clientId = $("#PLClientId").val();

  $msg.text("Cancelando puntos...");
  $loader.show();
  $container.hide();

  try {
    const response = await fetch(
      `${appUrl}/shopify/plcancelarpuntos?cliId=${clientId}&folio=${folio}&sucNum=${sucursal}&sucNom=${localStorage.getItem(
        "suc_name"
      )}`
    );

    const data = await response.json();
    $loader.hide();
    $container.show();

    if (!data.status) {
      $msg.html("<b>No pudimos devolver tus puntos. Intenta de nuevo.</b>");
      return;
    }

    await PLConsultaPuntos();

    $.post("/cart/update.js", "attributes[folioRedencion]=");
    $('#frm-cart-recap [name="discount"]').val("");

    $("#frmPuntos").show();
    $(".podria-acumular").show();
    $("#dsctoPuntosInfo, #dsctoPuntosInfo1").hide();
    $("#puntosAplicados").text(0);
    $("#prevPuntosContainer").show();

    $msg.html(
      '<span style="color:black;font-size:15px;font-weight:100;font-style:italic">Recuerda que 1 punto es igual a 1 peso</span>'
    );
  } catch (error) {
    console.error("Error al cancelar puntos:", error);
    $msg.html(
      "<b>Hubo un error al cancelar los puntos. Intenta más tarde.</b>"
    );
  } finally {
    $loader.hide();
    $container.show();
  }
}

async function PLPrevioPuntos() {
  try {
    const cartRes = await fetch("/cart.js");
    const cartJson = await cartRes.json();

    const data = {
      cliId: $("#PLClientId").val(),
      sucNum: sucursal,
      sucNom: localStorage.getItem("suc_name"),
      cart: cartJson,
    };

    const response = await fetch(appUrl + "/shopify/plpreviopuntos", {
      method: "POST",
      body: JSON.stringify(data),
      redirect: "follow",
    });

    const result = await response.json();

    if (result.status) {
      $("#prevPuntosInfo").text(result.puntos);
    }
  } catch (error) {
    console.error("Error en PLPrevioPuntos:", error);
  }
}

async function PLGetDescuentoActivo() {
  try {
    const cliId = $("#PLClientId").val();

    const response = await fetch(appUrl + "/shopify/plgetdescuentoactivo", {
      method: "POST",
      body: JSON.stringify({ cliId }),
      redirect: "follow",
    });

    const data = await response.json();

    if (data.status) {
      $.post(
        "/cart/update.js",
        "attributes[folioRedencion]=" + data.descuento.folio
      );
      $("#btnCancelarPuntos").attr("data-folio", data.descuento.folio);
      discount_param = data.descuento.code;

      $("#frm-cart-recap").attr(
        "action",
        $("#frm-cart-recap").attr("action") + "&discount=" + discount_param
      );

      $("#puntosAplicados").text(data.descuento.monto);
      $(".podria-acumular").hide();
      $("#prevPuntosContainer").hide();
      $("#frmPuntos").hide();
      $("#dsctoPuntosInfo").show();
      $("#dsctoPuntosInfo1").show();

      // Reafirmar el código de descuento en el formulario
      setTimeout(() => {
        $('#frm-cart-recap [name="discount"]').val(data.descuento.code);
      }, 2500);
    }
  } catch (error) {
    console.error("Error en PLGetDescuentoActivo:", error);
  }
}

/*function buscarDescuento(){ 
  var monto = $('#txtPuntos').val();
  var params = '?'+Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
  var discount = "";

  var requestOptions = {
    method: 'GET',
    //headers: myHeaders,
    redirect: 'follow'
    //mode: 'cors'
  };
  
  fetch(appUrl+"/giftcards/giftcards.json"+params, requestOptions)
  .then(response => response.json())
  .then(function(data){
    console.log(data);
    for(var k in data) {
      if(data[k].amount == ""+monto){
        discount = data[k].code;
        break;
      }
    }
    
    if(discount != ""){
      PLTmpCongelarPuntos(discount);
    }else{
      $('#programaLealtadMsg').html('<b>No pudimos devolver tus puntos. Por favor, vuelve a intentarlo.</b>');
    }
  }).catch(error => console.log('error', error));
}*/

/*$(document).on("click", "#btnUsarPuntos", function () {
  //crearDescuento("demo@gmail.com", $('#txtPuntos').val());
  var txtPun = $("#txtPuntos").val();
  if (txtPun != "") {
    if (parseFloat(txtPun) > parseFloat(misPuntos)) {
      $("#PLLoadingImg").hide();
      $("#programaLealtadMsg").html(
        "Solo puedes canjear " + misPuntos + " puntos como máximo"
      );
    } else {
      PLUsarPuntos();
    }
  } else {
    $("#programaLealtadMsg").html(
      "Debes ingresar los puntos que quieres utilizar"
    );
  }
});*/
$(document).on("click", "#btnUsarPuntos", function () {
  // Tomamos el valor raw y lo parseamos
  var raw = $("#txtPuntos").val();
  var amt = parseInt(raw, 10);

  // Sobrescribimos el input con el entero (descarta decimales)
  $("#txtPuntos").val(amt);

  // Validación: no vacío, debe ser número y entero
  if (raw === "" || isNaN(amt) || !/^\d+$/.test(raw)) {
    $("#programaLealtadMsg").html("Debes ingresar un número entero de puntos");
    return;
  }

  if (amt > parseFloat(misPuntos)) {
    $("#PLLoadingImg").hide();
    $("#programaLealtadMsg").html(
      "Solo puedes canjear " + misPuntos + " puntos como máximo"
    );
  } else {
    PLUsarPuntos();
  }
});

$(document).on("click", "#btnCancelarPuntos", function () {
  var folio = $("#btnCancelarPuntos").attr("data-folio");
  if (folio != null) {
    PLCancelarPuntos(folio);
  } else {
    $("#frmPuntos").show();
    $("#dsctoPuntosInfo").hide();
    $("#dsctoPuntosInfo1").hide();
  }
});

//---End programa lealtad---

/*function fillDeliveryInfo() {
  $("#cart-suc-name").html(localStorage.getItem("suc_name"));
  $("#cart-suc-dir").html(localStorage.getItem("suc_dir"));
  $("#cart-suc-horario").html(localStorage.getItem("suc_horario"));
  $("#cart-suc-tel").html(localStorage.getItem("suc_tel"));

  if (localStorage.getItem("delivery_type") == "domicilio") {
    $("#cart-dom-name").html(
      "RECIBE: " + localStorage.getItem("dir_firstname")
    );
    $("#cart-dom-tel").html("Tel. " + localStorage.getItem("dir_telephone"));
    $("#cart-dom-dir").html(
      localStorage.getItem("dir_street") +
        " " +
        localStorage.getItem("dir_city") +
        " " +
        localStorage.getItem("dir_state")
    );
    $("#cart-dom-indic").html(localStorage.getItem("dir_indications"));
  } else {
    $(".cart-domicilio").hide();
  }
}*/
function fillDeliveryInfo() {
  console.log("Ejecutando fillDeliveryInfo");

  // Recuperar desde localStorage
  let sucName = localStorage.getItem("suc_name");
  let sucDir = localStorage.getItem("suc_dir");
  let sucHorario = localStorage.getItem("suc_horario");
  let sucTel = localStorage.getItem("suc_tel");

  // Si falta algún dato, intenta recuperar desde cookies
  if (!sucName || !sucDir || !sucHorario || !sucTel) {
    const cookies = document.cookie.split(";").reduce((acc, cookie) => {
      const [key, value] = cookie.trim().split("=");
      acc[key] = decodeURIComponent(value);
      return acc;
    }, {});

    if (cookies.sucursalBackup) {
      try {
        const sucursal = JSON.parse(cookies.sucursalBackup);
        sucName = sucursal.name;
        sucDir = sucursal.dir;
        sucHorario = sucursal.horario;
        sucTel = sucursal.tel;
        console.log("Sucursal recuperada de cookie", sucursal);
      } catch (e) {
        console.warn("No se pudo leer la cookie de respaldo", e);
      }
    }
  }

  // Mostrar en la vista del carrito
  $("#cart-suc-name").html(sucName || "Sucursal no disponible");
  $("#cart-suc-dir").html(sucDir || "");
  $("#cart-suc-horario").html(sucHorario || "");
  $("#cart-suc-tel").html(sucTel || "");

  // Envío a domicilio (si aplica)
  if (localStorage.getItem("delivery_type") === "domicilio") {
    $("#cart-dom-name").html(
      "RECIBE: " + localStorage.getItem("dir_firstname")
    );
    $("#cart-dom-tel").html("Tel. " + localStorage.getItem("dir_telephone"));
    $("#cart-dom-dir").html(
      localStorage.getItem("dir_street") +
        " " +
        localStorage.getItem("dir_city") +
        " " +
        localStorage.getItem("dir_state")
    );
    $("#cart-dom-indic").html(localStorage.getItem("dir_indications"));
  } else {
    $(".cart-domicilio").hide();
  }
}

/************** timer ****************/
var timer_id;
if (is_mobile) {
  timer_id = "countdown-mobile";
} else {
  timer_id = "countdown";
}
/*
function startTimer(){
  var total_seconds;
   var timer = new Timer();
  var  timer_cookie=getCookie('timerstarted');
  $('#countdown').fadeIn();
  
 
  
  if(timer_cookie){
    
    var current_time = new Date();
    
   var elapsed_time= (current_time/1000) - timer_cookie;
  
    total_seconds=300-elapsed_time;
    console.log('elapsed_time '+elapsed_time+' total_seconds '+total_seconds+' timer_cookie '+timer_cookie);
     timer.start({countdown: true, startValues: {seconds: Math.trunc(parseFloat(total_seconds))}});
 
  }else{
    var start_time = new Date();
  setCookie('timerstarted',(start_time/1000),0.00347222); 
     timer.start({countdown: true, startValues: {seconds: 300}});
  }
  
  
 
 
$('#countdown .values').html(timer.getTimeValues().toString(['minutes', 'seconds']));
timer.addEventListener('secondsUpdated', function (e) {
    $('#countdown .values').html(timer.getTimeValues().toString(['minutes', 'seconds']));
});
timer.addEventListener('targetAchieved', function (e) {
    $('#countdown .values').css('font-size','20px').css('line-height','20px').html('SE ACABO TU TIEMPO');
      
});
  
}*/
var timer;
function startTimer() {
  var total_seconds;
  timer = new Timer();
  var timer_cookie = getCookie("timerstarted");
  $("#" + timer_id).fadeIn();
  console.log("start timer " + timer_id);

  if (timer_cookie) {
    var current_time = new Date();

    var elapsed_time = current_time / 1000 - timer_cookie;

    total_seconds = 300 - elapsed_time;
    console.log(
      "elapsed_time " +
        elapsed_time +
        " total_seconds " +
        total_seconds +
        " timer_cookie " +
        timer_cookie
    );
    timer.start({
      countdown: true,
      startValues: { seconds: Math.trunc(parseFloat(total_seconds)) },
    });
  } else {
    var start_time = new Date();
    setCookie("timerstarted", start_time / 1000, 1);
    timer.start({ countdown: true, startValues: { seconds: 300 } });
  }

  $("#" + timer_id + " .values").html(
    timer.getTimeValues().toString(["minutes", "seconds"])
  );
  timer.addEventListener("secondsUpdated", function (e) {
    $("#" + timer_id + " .values").html(
      timer.getTimeValues().toString(["minutes", "seconds"])
    );
  });
  timer.addEventListener("targetAchieved", function (e) {
    // $('#countdown .values').css('font-size','20px').css('line-height','20px').html('SE ACABO TU TIEMPO');
    $(".backdrop").fadeIn();
    $("#timeout").fadeIn();
    eraseCookie("timerstarted");
    setCookie("timercomplete", "true", 1);
  });
}
function stopTimer() {
  timer.stop();
  $("#" + timer_id).fadeOut();
  eraseCookie("timercomplete");
  eraseCookie("timerstarted");
}
$(document).ready(function () {
  if (
    getCookie("timerstarted") &&
    localStorage.getItem("delivery_type") == "domicilio"
  ) {
    startTimer();
  }
  if (getCookie("timercomplete")) {
    $("#" + timer_id + " .values")
      .css("font-size", "20px")
      .css("line-height", "20px")
      .html("SE ACABO TU TIEMPO");
    //$('.backdrop').fadeIn();
    //$('#timeout').fadeIn();
    eraseCookie("timercomplete");
    eraseCookie("timerstarted");
  }
});
/******** sucursales ********/
function getLocation2() {
  //backdrop('on');

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        document.getElementById("lat1").value = position.coords.latitude;
        document.getElementById("lon1").value = position.coords.longitude;

        getSucursales1();

        console.log(
          "buscando sucursales por ubicacion " +
            position.coords.latitude +
            " " +
            position.coords.longitude
        );
      },
      (error) => alert(error.message),
      { enableHighAccuracy: false, timeout: 5000 }
    );
  } else {
    alert("Tu navegador no soporta la geolocalización.");
  }
}

$(document).on("click", "#mi-ubicacion", function () {
  notInSucList1 = true;
  getLocation2();
});

var cartEndpoint = "/cart.js";

// Create a function to fetch the cart data
function fetchMTCart() {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "https://www.elglobo.com.mx" + cartEndpoint);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function () {
      if (xhr.status === 200) {
        var cart = JSON.parse(xhr.responseText);
        resolve(cart);
      } else {
        reject(xhr.statusText);
      }
    };
    xhr.onerror = function () {
      reject(xhr.statusText);
    };
    xhr.send();
  });
}

function fetchMTDCart(callback) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", "https://www.elglobo.com.mx" + cartEndpoint);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onload = function () {
    if (xhr.status === 200) {
      var cart = JSON.parse(xhr.responseText);
      callback(null, cart);
    } else {
      callback(xhr.statusText);
    }
  };
  xhr.onerror = function () {
    callback(xhr.statusText);
  };
  xhr.send();
}

$(document).on("click", "#btnComprarAhora", function (e) {
  e.preventDefault();

  var productoData = buscarProductoInfoPorSku(
    $('input[name="id"]').data("sku")
  );

  fetchMTDCart(function (error, cart) {
    if (error) {
      console.error(error);
    } else {
      var productId = $('input[name="id"]').val(); // Replace with the actual product ID you want to find
      var productExists = false;
      var productQuantity = 0;
      var prod;
      // Iterate over the line items in the cart
      cart.items.forEach(function (item) {
        console.log("item.id: ", item.id);
        if (item.id === parseInt(productId)) {
          productExists = true;
          productQuantity = item.quantity;
          prod = item;
        }
      });

      if (productExists) {
        console.log("item ", cart);
        if (parseInt(productQuantity) < parseInt(productoData.qty)) {
          $(".product-form").submit();
        } else {
          console.log("No contamos con inventario suficiente");
          $(".backdrop").fadeIn();
          $("#no-stock").fadeIn();
        }
      } else {
        $(".product-form").submit();
      }
    }
  });
});

/******** agregar bebidas al carrito ********/

$(document).on("click", ".product-link", function () {
  var qty_controls = $(this).attr("data-qty-controls");
  localStorage.setItem("itemsQty", $("#" + qty_controls).val());
});

$(document).ready(function () {
  if (current_collection == "BEBIDAS") {
    if (
      typeof localStorage.getItem("itemsQty") !== "undefined" &&
      localStorage.getItem("itemsQty") !== null
    ) {
      $(".eg-qty").attr("value", localStorage.getItem("itemsQty"));
      //console.log('Bebidas bebibles que se beben');
    }
  }

  //product_items=[];

  if (localStorage.getItem("sucursal")) {
    $("#gf-products").html("");
    getAllProducts();
  }
});

/*** Reordenamiento de Productos ***/

var custom_pages = "";

function getAllProducts(
  pageNumber = 1,
  products = [],
  filter = false,
  tags = "",
  sorting = "false"
) {
  allowHideProductos = false;

  if (pageNumber === 1) {
    $(".custom_pagination_container").remove();
    $("#collection__dynamic-part").append(
      '<div class="collection_backdrop"></div>'
    );
    $(".pagination").after('<div class="custom_pagination_container"></div>');
  }

  const mbProductosJSN =
    JSON.parse(localStorage.getItem("mbProductosJSN")) || [];
  const boton = document.querySelector(".button-filtro");
  let texto;
  if (boton) {
    const nodos = Array.from(boton.childNodes);
    texto = nodos.find((n) => n.nodeType === Node.TEXT_NODE);
  }

  let url_products;
  let searchProducts = false;
  let searchQuery;

  if (current_collection === "Productos") {
    if (filter) p_filtered = true;
    url_products = "/collections/all/products.json";
  } else if (current_collection === "HELADOS") {
    url_products = "/collections/postres/products.json";
  } else if (current_collection === "ESPECIAL DEL MES") {
    url_products = "/collections/temporada-1/products.json";
  } else if (filter) {
    p_filtered = true;
    url_products = `/collections/${current_collection}/products.json`;
  } else if (
    !current_collection &&
    window.location.pathname.startsWith("/search")
  ) {
    searchQuery =
      new URLSearchParams(window.location.search).get("q")?.toLowerCase() || "";
    searchProducts = true;
    url_products = "/collections/all/products.json";
  } else {
    url_products = `/collections/${current_collection.toLowerCase()}/products.json`;
  }

  $(".pagination").html("");

  let fullUrl = !searchProducts
    ? filter
      ? `/collections/${
          current_collection === "ESPECIAL DEL MES"
            ? "temporada-1"
            : current_collection === "HELADOS"
            ? "postres"
            : current_collection === "Productos"
            ? "all"
            : current_collection
        }/?view=json&page=${pageNumber}`
      : `${url_products}?page=${pageNumber}`
    : `/search?q=${searchQuery}&type=product&view=json&page=${pageNumber}`;

  fetch(fullUrl)
    .then((response) => response.json())
    .then((response) => {
      let respObj;
      if (searchProducts) {
        products = products.concat(response.results);
        respObj = response.results.length;
      } else if (filter) {
        const selectedTags = tags.split("+");
        const filteredProducts = response.results.filter((product) => {
          if (!Array.isArray(product.tags)) return false;
          return selectedTags.some((tag) =>
            product.tags.some(
              (prodTag) => prodTag.toLowerCase() === tag.toLowerCase()
            )
          );
        });

        products = tags.trim()
          ? products.concat(filteredProducts)
          : products.concat(response.results);

        if (texto)
          texto.textContent = tags.trim()
            ? `Filtrar (${selectedTags.length})`
            : "Filtrar";

        allFetchedFilteredProducts = products;
        respObj = response.results.length;
      } else {
        products = products.concat(response.products);
        respObj = response.products.length;
      }

      if (respObj > 0) {
        if (filter) getAllProducts(pageNumber + 1, products, true, tags);
        else if (sorting !== "false")
          getAllProducts(pageNumber + 1, products, false, "", sorting);
        else getAllProducts(pageNumber + 1, products);

        pageNumberCount = pageNumber + 1;
      } else {
        renderProducts(products, sorting, mbProductosJSN);
      }
    })
    .catch((error) => {
      console.error("Error al cargar productos:", error);
      $(".collection_backdrop").hide();
      $(".custom_pagination_container").html(
        "<p>Error cargando productos. Intenta de nuevo.</p>"
      );
    });
}

function renderProducts(products, sorting, mbProductosJSN) {
  $(".collection_backdrop").hide();

  products = products.filter(
    (product) =>
      product.product_type !== "EXTRAS" &&
      product.product_type !== "OPTIONS_HIDDEN_PRODUCT" &&
      product.product_type !== "CAMBIO DE LECHE"
  );

  if (sorting !== "false") {
    let sortedResults = p_filtered
      ? [...allFetchedFilteredProducts]
      : [...products];

    sortedResults.sort((a, b) => sortLogic(a, b, sorting));
    products = sortedResults;

    products.forEach((product) => assignStock(product, mbProductosJSN));

    allFetchedProducts = products;
  } else {
    products.forEach((product) => assignStock(product, mbProductosJSN));
    products.sort((a, b) => b.mbqty - a.mbqty);
  }

  //  Lazy render: procesar por tandas de 24
  let product_items = "";
  let batchSize = 24;
  let currentPage = 1;
  let totalPages = Math.ceil(products.length / batchSize);

  function renderBatch(startIndex) {
    const batch = products.slice(startIndex, startIndex + batchSize);
    const totalItems = products.length;

    batch.forEach((product, index) => {
      const globalIndex = startIndex + index;

      if (globalIndex % batchSize === 0) {
        const batchStart = globalIndex + 1;
        const batchEnd = Math.min(globalIndex + batchSize, totalItems);
        const batchRange = `${batchStart}-${batchEnd}`;

        $(".custom_pagination_container").append(
          `<span 
          data-custompage="${currentPage}" 
          data-start="${batchStart}" 
          data-end="${batchEnd}" 
          data-batch="${batchRange}" 
          class="custom_page_link">${currentPage}</span>`
        );

        currentPage++;
      }

      const pageClass = `page_${Math.ceil((globalIndex + 1) / batchSize)}`;
      product_items += buildProductItem(product, pageClass);
    });

    if (startIndex + batchSize < products.length) {
      requestIdleCallback(() => renderBatch(startIndex + batchSize));
    } else {
      $("#gf-products").html(product_items);
      $(".page_1").show();

      const total_found =
        $(".js-pagination").length < 24 ? $(".js-pagination").length : "24";
      $(".elg-results-text").html(
        'Mostrando <span id="elg-start">1</span> - <span id="elg-end">' +
          total_found +
          '</span> de <span id="elg-total">' +
          $(".js-pagination").length +
          " resultados</span>"
      );
      $("#sorted_by").html("");
      initialLoadCompleted = true;
      attachCollectionObserver();
      console.log(
        "Total de productos visibles en el DOM:",
        $(".js-pagination").length
      );
    }
  }

  renderBatch(0);
}

function assignStock(product, mbProductosJSN) {
  const mbProduct = mbProductosJSN.find(
    (item) => item.sku === product.variants[0]?.sku
  );
  product.mbqty = mbProduct
    ? product.product_type !== "BEBIDAS"
      ? mbProduct.qty
      : 10000
    : 0;
}

function sortLogic(a, b, sorting) {
  const priceA = parseFloat(a.variants?.[0]?.price) || 0;
  const priceB = parseFloat(b.variants?.[0]?.price) || 0;
  const titleA = (a.title || "").trim();
  const titleB = (b.title || "").trim();
  const idA = a.id || 0;
  const idB = b.id || 0;

  switch (sorting) {
    case "price-ascending":
      return priceA !== priceB
        ? priceA - priceB
        : titleA.localeCompare(titleB, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
          }) || idA - idB;
    case "price-descending":
      return priceA !== priceB
        ? priceB - priceA
        : titleB.localeCompare(titleA, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
          }) || idB - idA;
    case "title-ascending":
      return (
        titleA.localeCompare(titleB, undefined, {
          sensitivity: "base",
          ignorePunctuation: true,
        }) || priceA - priceB
      );
    case "title-descending":
      return (
        titleB.localeCompare(titleA, undefined, {
          sensitivity: "base",
          ignorePunctuation: true,
        }) || priceB - priceA
      );
    default:
      return 0;
  }
}

function buildProductItem(product, pageClass) {
  const sku = product.variants[0]?.sku || "";
  const id = product.id || "";
  const variantId = product.variants[0]?.id || "";
  const price = Math.round(parseFloat(product.variants[0]?.price) || 0);
  const title = product.title || "";
  const normalizedStr = (product.product_type || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();
  const tags = (Array.isArray(product.tags) ? product.tags : [])
    .map((tag) =>
      tag
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase()
    )
    .join(" ");
  const imageSrc = product.images[0]?.src || "";
  const onlineAvailable =
    parseInt(product.mbqty) > 0 ? "display:block" : "display:none";
  const onlineAvailableFlex =
    parseInt(product.mbqty) > 0 ? "display:flex" : "display:none";
  // const sucursalOnly = parseInt(product.mbqty) > 0 ? "display:none" : "display:block";
  var sucursalOnly =
    parseInt(product.mbqty) === 0 && product.product_type !== "BEBIDAS"
      ? "display:block"
      : "display:none";
  return `
  <div data-sga-prd-sku="${sku}" data-addtc-button="addtc-${id}" data-sga-tags="${tags}" 
    class="js-pagination ${pageClass} product-item product-item--vertical 1/3--tablet-and-up 1/3--desk" data-type-prod="PASTELES">
    
    <a href="/collections/${normalizedStr}/products/${
    product.handle
  }" class="product-item__image-wrapper">
      <div class="aspect-ratio" style="padding-bottom:79.150390625%">
        <img class="product-item__primary-image image--fade-in lazyautosizes lazyloaded" 
          data-media-id="20302781153338" data-sizes="auto" data-widths="[200,300,400,500,600,700,800]"
          alt="${title}" data-srcset="${imageSrc}" src="${imageSrc}">
        <noscript>
          <img src="https://www.elglobo.com.mx/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_600x.gif" alt="${title}">
        </noscript>
      </div>
    </a>

    <div class="product-item__info">
      <div class="item-details-col">
        <div class="product-item__info-inner">
          <a href="/collections/${normalizedStr}/products/${
    product.handle
  }" class="product-item__title">${title}</a>
          <div class="product-item__price-list price-list">
            <span class="price" data-price="${price}">
              <span class="visually-hidden">Precio de venta</span>$${price}
            </span>
          </div>
        </div>

        <div class="product-form__info-item product-form__info-item--quantity transform-precio-productos" style="${onlineAvailableFlex}">
          <div class="product-form__info-content">
            <div class="quantity-selector quantity-selector--product eg-producto-cantidad">
              <button type="button" class="quantity-selector__button birria" data-action="custom-decrease-quantity" aria-label="Disminuir la cantidad en 1" title="Disminuir la cantidad en 1">
                <svg focusable="false" class="icon icon--minus" viewBox="0 0 10 2" role="presentation">
                  <path d="M10 0v2H0V0z" fill="currentColor"></path>
                </svg>
              </button>
              <input name="quantity" aria-label="Cantidad" class="quantity-selector__value" id="qty-${id}" inputmode="numeric" value="1" size="3" readonly="">
              <button type="button" class="quantity-selector__button" data-action="custom-increase-quantity" aria-label="Aumentar la cantidad en 1" title="Aumentar la cantidad en 1" value="1">
                <svg focusable="false" class="icon icon--plus" viewBox="0 0 10 10" role="presentation">
                  <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="item-details-col">
        <form method="post" action="/cart/add" id="product_form_id_${id}_collection-template" accept-charset="UTF-8" class="product-item__action-list button-stack no_bold_options" enctype="multipart/form-data">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="quantity" value="1">
          <input type="hidden" name="id" value="${variantId}">
          <input type="hidden" name="sku" value="${sku}">
          <input type="hidden" name="category1" value="${product.product_type}">
          <input type="hidden" name="p_name" value="${title}">

          ${
            product.product_type === "BEBIDAS"
              ? `<a href="/collections/${normalizedStr}/products/${product.handle}" class="product-item__action-button button button--small button--primary product-link" data-qty-controls="qty-${id}">Agregar</a>`
              : `<button id="addtc-${id}" type="submit" class="icon-addtocart-button product-item__action-button button button--small button--primary" data-action="add-to-cart" data-available="${product.mbqty}" style="${onlineAvailable}">Agregar</button>`
          }

          <button type="button" class="product-item__action-button product-item__action-button--list-view-only button button--small button--ternary hidden-phone hidden" data-action="open-modal" data-secondary-action="open-quick-view" aria-controls="modal-quick-view-collection-template" data-product-url="/products/mascarpone">Vista rápida</button>

          <input type="hidden" name="product-id" value="${id}">
          <input type="hidden" name="section-id" value="collection-template">
        </form>

        <div class="no-stock-message" style="${sucursalOnly}">SOLO DISPONIBLE EN SUCURSAL</div>
      </div>
    </div>
  </div>`;
}

function sortByQty(a, b) {
  return b.qty - a.qty;
}

$(document).on("click", ".custom_page_link", function (event) {
  event.preventDefault();

  $(".custom_page_link_active").removeClass("custom_page_link_active");
  var current_custom_page = $(this).data("custompage");
  $(this).addClass("custom_page_link_active");
  $(".js-pagination").hide();
  $(".page_" + current_custom_page).show();

  $("html, body").animate(
    {
      scrollTop: $(".page__sub-header").offset().top,
    },
    600
  );
});
/*
$.getJSON('/collections/pasteles/products.json', function(response) {
   
   // that.products = response;
  });
*/

//ordenamiento de productos
(function () {
  function bloquearOrdenamientoNativo() {
    const sortContainer = document.getElementById("sort-by-selector");
    if (!sortContainer) return;

    sortContainer
      .querySelectorAll("[data-action='select-value']")
      .forEach((btn) => {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          // quitar 'is-selected' a todos
          sortContainer
            .querySelectorAll(".is-selected")
            .forEach((selectedBtn) => {
              selectedBtn.classList.remove("is-selected");
            });

          // agregar 'is-selected' al botón clickeado
          btn.classList.add("is-selected");

          const sortValue = btn.getAttribute("data-value");
          const newURL = window.location.origin + window.location.pathname;
          window.history.replaceState({}, "", newURL);
          // getAllProducts(1, [], false, '', sortValue);
          if (sortValue == "title-ascending") {
            $("#sorted_by").html("Alfabéticamente, A-Z");
          } else if (sortValue == "title-descending") {
            $("#sorted_by").html("Alfabéticamente, Z-A");
          } else if (sortValue == "price-ascending") {
            $("#sorted_by").html("Precio, menor a mayor");
          } else if (sortValue == "price-descending") {
            $("#sorted_by").html("Precio, mayor a menor");
          } else {
            $("#sorted_by").html("");
          }

          paginateItemsCollection(24, sortValue);
          console.log("Hola tu");
        });
      });
  }

  function mostrarLoadingIcon() {
    const container = document.getElementById("gf-products");
    if (!container) return;

    // Eliminar si ya existe
    const existente = document.getElementById("prd-loading-icon");
    if (existente) existente.remove();

    const loadingIcon = document.createElement("div");
    loadingIcon.id = "prd-loading-icon";
    loadingIcon.style.textAlign = "center";
    loadingIcon.style.width = "100%";
    loadingIcon.innerHTML = `<img src="//www.elglobo.com.mx/cdn/shop/t/93/assets/loading_1000x1000.gif?v=9816962998190746701744830252" width="150" alt="cargando">`;

    container.prepend(loadingIcon);
  }

  function ordenarProductosInyectados(sortBy) {
    const container = document.getElementById("gf-products");
    if (!container) return;

    let productos = Array.from(container.querySelectorAll(".product-item"));
    productos = productos.filter(
      (el) => !el.id || el.id !== "prd-loading-icon"
    );

    if (sortBy === "price-ascending" || sortBy === "price-descending") {
      productos.sort((a, b) => {
        const aPrecio = parseFloat(
          (a.querySelector(".price")?.textContent || "0").replace(
            /[^0-9.]/g,
            ""
          )
        );
        const bPrecio = parseFloat(
          (b.querySelector(".price")?.textContent || "0").replace(
            /[^0-9.]/g,
            ""
          )
        );
        return sortBy === "price-ascending"
          ? aPrecio - bPrecio
          : bPrecio - aPrecio;
      });
    }

    if (sortBy === "title-ascending" || sortBy === "title-descending") {
      productos.sort((a, b) => {
        const aTitulo =
          a
            .querySelector(".product-item__title")
            ?.textContent?.trim()
            ?.toLowerCase() || "";
        const bTitulo =
          b
            .querySelector(".product-item__title")
            ?.textContent?.trim()
            ?.toLowerCase() || "";
        return sortBy === "title-ascending"
          ? aTitulo.localeCompare(bTitulo)
          : bTitulo.localeCompare(aTitulo);
      });
    }

    // Simular tiempo de carga con animación visible antes de renderizar
    setTimeout(() => {
      container.innerHTML = "";
      productos.forEach((p) => container.appendChild(p));

      // Ocultar ícono de carga
      const loadingIcon = document.getElementById("prd-loading-icon");
      if (loadingIcon) loadingIcon.remove();
    }, 1000);
  }

  document.addEventListener("DOMContentLoaded", bloquearOrdenamientoNativo);
})();

//filtrado de productos (aun no es funcional)
(function () {
  // Almacena el HTML completo de todos los productos
  window.fullProductsHTML = "";

  // Función asíncrona para cargar todos los productos desde varias páginas
  async function fetchAllPages() {
    const cont = document.getElementById("gf-products");
    if (!cont) return;

    // Obtiene el número total de páginas en la paginación
    const totalPages = parseInt(
      document.querySelector(".pagination li:last-child")?.innerText || "1"
    );
    let fullHTML = cont.innerHTML;

    // Muestra el ícono de carga mientras se obtienen los productos
    mostrarLoadingIcon();

    // Itera sobre todas las páginas de productos y las agrega al HTML completo
    for (let i = 2; i <= totalPages; i++) {
      try {
        // Obtiene los datos de la página i
        const response = await fetch(window.location.pathname + `?page=${i}`);
        const text = await response.text();
        const html = document.createElement("div");
        html.innerHTML = text;

        // Extrae los productos de la página y los agrega a la variable fullHTML
        const products = html.querySelector("#gf-products");
        if (products) {
          fullHTML += products.innerHTML;
        }
      } catch (err) {
        console.error(`Error cargando página ${i}:`, err);
      }
    }

    // Una vez cargados todos los productos, almacena el HTML completo
    window.fullProductsHTML = fullHTML;
    // Filtra los productos inyectados según los criterios seleccionados
    window.filtrarProductosInyectados();
  }

  // Obtiene los criterios de filtro seleccionados por el usuario
  function obtenerCriteriosSeleccionados() {
    const tags = new Set();

    // Agrega las etiquetas de los filtros seleccionados
    document
      .querySelectorAll(".collection__filter-checkbox-list input:checked")
      .forEach((i) => i.dataset.tag && tags.add(i.dataset.tag.toLowerCase()));

    // Agrega las etiquetas de los filtros seleccionados a través de enlaces
    document
      .querySelectorAll(
        '.collection__filter-link.is-selected, [data-action="toggle-tag"].is-selected'
      )
      .forEach(
        (el) => el.dataset.tag && tags.add(el.dataset.tag.toLowerCase())
      );

    // Normaliza las etiquetas para que estén en un formato consistente
    return Array.from(tags).map((t) =>
      t
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/_/g, "-")
        .replace(/\s+/g, "-")
        .toLowerCase()
    );
  }

  // Función para renderizar los productos filtrados en la página
  function renderFilteredAll(filteredItems) {
    const cont = document.getElementById("gf-products");
    if (!cont) return;
    cont.innerHTML = "";
    console.log("filteredItems", filteredItems);
    // Muestra los productos filtrados
    filteredItems.forEach((item) => {
      item.classList.remove("hidden");
      item.style.display = "";
      cont.appendChild(item);
    });

    // Oculta la paginación después de filtrar
    const pagination = document.querySelector(".pagination, .paginate");
    if (pagination) pagination.style.display = "none";
  }

  // Función principal para filtrar los productos inyectados
  window.filtrarProductosInyectados = function () {
    const cont = document.getElementById("gf-products");
    if (!cont || !window.fullProductsHTML) return;

    const selectedTags = obtenerCriteriosSeleccionados();

    // Si no hay filtros seleccionados, muestra todos los productos
    if (selectedTags.length === 0) {
      cont.innerHTML = window.fullProductsHTML;
      const pagination = document.querySelector(".pagination, .paginate");
      if (pagination) pagination.style.display = "";
      return;
    }

    // Crea un contenedor temporal para filtrar los productos
    const temp = document.createElement("div");
    temp.innerHTML = window.fullProductsHTML;
    const allItems = Array.from(temp.querySelectorAll(".product-item"));

    // Filtra los productos según las etiquetas seleccionadas
    const filteredItems = allItems.filter((item) => {
      const raw = (item.dataset.sgaTags || "").split(/\s+/);
      const tags = raw.map((t) =>
        t
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/_/g, "-")
          .replace(/\s+/g, "-")
          .toLowerCase()
      );
      return selectedTags.some((tag) => tags.includes(tag));
    });

    // Si no se encuentran productos filtrados, muestra un mensaje
    if (filteredItems.length === 0) {
      cont.innerHTML =
        "<p>No se encontraron productos con el filtro seleccionado.</p>";
      return;
    }

    // Renderiza los productos filtrados en la página
    //renderFilteredAll(filteredItems);
  };

  // Función para mostrar el ícono de carga mientras se cargan los productos
  function mostrarLoadingIcon() {
    const container = document.getElementById("gf-products");
    if (!container) return;

    // Elimina el ícono de carga si ya existe
    const existente = document.getElementById("prd-loading-icon");
    if (existente) existente.remove();

    // Crea y agrega el ícono de carga al contenedor de productos
    const loadingIcon = document.createElement("div");
    loadingIcon.id = "prd-loading-icon";
    loadingIcon.style.textAlign = "center";
    loadingIcon.style.width = "100%";
    loadingIcon.innerHTML = `<img src="//www.elglobo.com.mx/cdn/shop/t/93/assets/loading_1000x1000.gif?v=9816962998190746701744830252" width="150" alt="cargando">`;

    container.prepend(loadingIcon);
  }

  // Evento para escuchar los cambios en los filtros y aplicarlos
  /*document.addEventListener("click", async e => {
    const el = e.target.closest('[data-action="toggle-tag"], [data-action="apply-filters"], [data-action="clear-tags"], .collection__filter-link');
    if (!el) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    // Cambia el estado de los filtros al ser seleccionados
    if (el.matches('[data-action="toggle-tag"], .collection__filter-link')) {
      el.classList.toggle("is-selected");
      el.classList.toggle("is-active");
    }

    // Si no se han cargado todos los productos, los carga
    if (!window.fullProductsHTML || window.fullProductsHTML.length < 1000) {
      await fetchAllPages();
    } else {
      window.filtrarProductosInyectados();
    }
  }, true);*/

  // Evento para escuchar los cambios en los checkboxes de filtros
  document.addEventListener(
    "change",
    async (e) => {
      if (!e.target.matches(".collection__filter-checkbox-list input")) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const tag = e.target.dataset.tag;
      console.log("Valor de data-tag:", tag);
      /*
    // Si no se han cargado todos los productos, los carga
    if (!window.fullProductsHTML || window.fullProductsHTML.length < 1000) {
      await fetchAllPages();
    } else {
      window.filtrarProductosInyectados();
    }*/
    },
    true
  );
})();

document.addEventListener("DOMContentLoaded", function () {
  const filtroBtns = document.querySelectorAll(".filtros-listos");

  if (filtroBtns.length > 0) {
    filtroBtns.forEach(function (filtroBtn) {
      filtroBtn.addEventListener("click", function () {
        const target = document.querySelector(".container--flush");
        if (target) {
          target.click();
        }

        if (window.innerWidth <= 768) {
          const mobileFilters = document.querySelector(
            ".collection-drawer__close"
          );
          if (mobileFilters) {
            mobileFilters.click();
          }
        }
      });
    });
  } else {
  }
});

/***** MOSTRAR X POR PAGINA *****/
function paginateItems(perPage) {
  const container = document.getElementById("gf-products");
  const items = Array.from(container.children);
  const totalItems = items.length;
  const totalPages = Math.ceil(totalItems / perPage);

  // Limpiar clases previas page_X y ocultar todos
  items.forEach((item) => {
    item.className = item.className.replace(/\bpage_\d+\b/g, "");
    item.style.display = "none";
  });

  // Reasignar clases de paginación
  items.forEach((item, index) => {
    const page = Math.floor(index / perPage) + 1;
    item.classList.add(`page_${page}`);
  });

  // Mostrar solo la primera página
  const firstPageItems = container.querySelectorAll(".page_1");
  firstPageItems.forEach((item) => {
    item.style.display = "block";
  });

  // Crear botones de paginación
  const paginationContainer = document.querySelector(
    ".custom_pagination_container"
  );
  paginationContainer.innerHTML = ""; // Limpiar botones anteriores

  for (let i = 1; i <= totalPages; i++) {
    const start = (i - 1) * perPage + 1;
    const end = Math.min(i * perPage, totalItems);

    const span = document.createElement("span");
    span.setAttribute("data-custompage", i);
    span.setAttribute("data-start", start);
    span.setAttribute("data-end", end);
    span.className = "custom_page_link";
    span.textContent = i;
    paginationContainer.appendChild(span);
  }

  // Mostrar contador inicial (primera página)
  document.getElementById("elg-start").textContent = 1;
  document.getElementById("elg-end").textContent = Math.min(
    perPage,
    totalItems
  );
  document.getElementById("elg-total").textContent = totalItems;

  console.log(
    `Paginado en ${totalPages} páginas con ${perPage} ítems por página.`
  );
}

function paginateItemsCollection(perPage, sortOrder) {
  const container = document.getElementById("gf-products");
  let items = Array.from(container.children);
  const totalItems = items.length;

  // ORDENAMIENTO según sortOrder
  items.sort((a, b) => {
    if (sortOrder === "price-ascending" || sortOrder === "price-descending") {
      const priceA = parseFloat(a.querySelector(".price")?.dataset.price || 0);
      const priceB = parseFloat(b.querySelector(".price")?.dataset.price || 0);
      return sortOrder === "price-ascending"
        ? priceA - priceB
        : priceB - priceA;
    }

    if (sortOrder === "title-ascending" || sortOrder === "title-descending") {
      const titleA =
        a
          .querySelector(".product-item__title")
          ?.textContent.trim()
          .toLowerCase() || "";
      const titleB =
        b
          .querySelector(".product-item__title")
          ?.textContent.trim()
          .toLowerCase() || "";
      if (titleA < titleB) return sortOrder === "title-ascending" ? -1 : 1;
      if (titleA > titleB) return sortOrder === "title-ascending" ? 1 : -1;
      return 0;
    }

    return 0; // Sin cambios si no hay criterio válido
  });

  // Limpiar el contenedor
  container.innerHTML = "";
  items.forEach((item) => {
    item.style.display = "none"; // Ocultar para paginación
    container.appendChild(item); // Reinsertar ordenado
  });

  const totalPages = Math.ceil(totalItems / perPage);

  // Reasignar clases de paginación
  items.forEach((item, index) => {
    item.className = item.className.replace(/\bpage_\d+\b/g, "");
    const page = Math.floor(index / perPage) + 1;
    item.classList.add(`page_${page}`);
  });

  // Mostrar solo la primera página
  container.querySelectorAll(".page_1").forEach((item) => {
    item.style.display = "block";
  });

  // Crear paginación
  const paginationContainer = document.querySelector(
    ".custom_pagination_container"
  );
  if (paginationContainer) {
    paginationContainer.innerHTML = "";
    for (let i = 1; i <= totalPages; i++) {
      const start = (i - 1) * perPage + 1;
      const end = Math.min(i * perPage, totalItems);

      const span = document.createElement("span");
      span.setAttribute("data-custompage", i);
      span.setAttribute("data-start", start);
      span.setAttribute("data-end", end);
      span.className = "custom_page_link";
      span.textContent = i;
      paginationContainer.appendChild(span);
    }
  }

  // Contadores de resultados
  // document.getElementById('elg-start').textContent = 1;
  //document.getElementById('elg-end').textContent = Math.min(perPage, totalItems);
  //document.getElementById('elg-total').textContent = totalItems;

  console.log(`Ordenado por ${sortOrder} y paginado en ${totalPages} páginas.`);
}
